<span class="d-inline-flex position-relative">
  <ng-content></ng-content>
  @if (hasUnredeemedItems()) {
    <span class="badge bg-danger position-absolute rounded-pill top-0 start-100 translate-y-40">
      {{ countDisplayText() }}
      <span class="visually-hidden">{{ 'fgbcl.rewards.wallet.a11y.unredeemed.rewards' | translate }}</span>
    </span>
  }
</span>
